import {
    useEffect
} from 'react';

import Router from './router';

export default function App() {
    useEffect(() => {
        window.history.scrollRestoration = 'manual';
    }, []);
    
    return <Router/>;
};
